import { ReactElement } from 'react'
import illustration from '../images/Tonno1.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Olen, aloitetaan!',
    gotoStage: 2
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const TonnoStage1 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle>Juhannusyön taikaa Tönnön kylässä</StageTitle>
      <StageText>
        Nauhakaupungin juhannusyössä sattuu ja tapahtuu;<br/>
        tämä matka voi olla kattavampi kuin mitä luulisit.
      </StageText>
      <StageText>
        <strong>Oletko valmis seikkailuun?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default TonnoStage1
